import { atom } from "jotai"
import { store } from "@/store/store"

export type ColorMatchImageUploadStatus = "uploading" | "failed" | "synced"

export const colorMatchImageUploadStatusesAtom = atom<
	Record<string, ColorMatchImageUploadStatus | undefined>
>({})

export const setColorMatchImageUploadStatus = (
	imageId: string,
	status: ColorMatchImageUploadStatus,
) => {
	store.set(colorMatchImageUploadStatusesAtom, (prev) => ({
		...prev,
		[imageId]: status,
	}))
}
